<button
  type="button"
  class="{{buttonClass}}"
  (click)="toggleMenu()"
  cdkOverlayOrigin
  #buttonOrigin="cdkOverlayOrigin"
>
  <ng-content></ng-content>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="buttonOrigin"
  [cdkConnectedOverlayOpen]="menuOpen"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayPositions]="overlayPositions"
>
  <div
    #menuOverlay
    class="menu"
    role="menu"
  >
    @if (menuTitle) {
      <div class="menu-item title">
        {{menuTitle}}
      </div>
    }

    @for (option of currentOptions?.options || []; track option.id) {
      <a
        [attr.data-id]="option.id"
        role="menuitem"
        class="menu-item"
        (click)="onOptionClick(option)"
      >
        <div class="text">
          @if (option.icon) {
            <i class="{{option.icon.includes(' ') ? option.icon : 'fa-regular fa-fw fa-' + option.icon}}" style="margin-right: 2px;"></i>
          }
          {{option.name}}
        </div>
      </a>
    }
  </div>
</ng-template>
